import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const GAMES = [
  {
    slug: "runway-themes",
    title: "Runway Themes",
    description: "Dress up + score for the theme.",
    icon: "👗",
    gradient: "from-pink-200 to-purple-200",
  },
  {
    slug: "pocket-garden",
    title: "Pocket Garden",
    description: "Plant, wait, harvest, and grow your garden.",
    icon: "🌱",
    gradient: "from-green-200 to-emerald-200",
  },
  {
    slug: "kitten-cafe-merge",
    title: "Kitten Café Merge",
    description: "Merge cute café items and beat your best score.",
    icon: "🐾",
    gradient: "from-orange-200 to-yellow-200",
  },
];

export default function GamesHubPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen px-6 py-8 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h1 className="font-fredoka text-5xl md:text-6xl font-bold text-foreground mb-4">
          Games 🎮
        </h1>
        <p className="font-nunito text-lg text-muted-foreground">
          Pick a game to play.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {GAMES.map((game, index) => (
          <motion.button
            key={game.slug}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.08 }}
            onClick={() => navigate(`/games/${game.slug}`)}
            className={`text-left bg-gradient-to-br ${game.gradient} border-2 border-border rounded-3xl shadow-hard-lg p-6 hover:shadow-hard-xl hover:-translate-y-1 transition-all`}
          >
            <div className="text-center mb-4">
              <span className="text-6xl mb-3 block">{game.icon}</span>
              <h3 className="font-fredoka text-2xl font-bold text-foreground mb-2">
                {game.title}
              </h3>
              <p className="font-nunito text-muted-foreground">{game.description}</p>
            </div>

            <div className="mt-4 text-center">
              <span className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-primary text-white font-fredoka font-semibold shadow-hard">
                Play
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
